import { render, staticRenderFns } from "./FacialResult.vue?vue&type=template&id=024bdfeb&scoped=true"
import script from "./FacialResult.vue?vue&type=script&lang=js"
export * from "./FacialResult.vue?vue&type=script&lang=js"
import style0 from "@pds/typography/typography.min.css?vue&type=style&index=0&id=024bdfeb&prod&scoped=true&lang=css&external"
import style1 from "./FacialResult.vue?vue&type=style&index=1&id=024bdfeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024bdfeb",
  null
  
)

export default component.exports